<template>
  <div class="inventory-items-list">
    <PagesInventoryItemsListItemCard
      v-for="item in items.filter(Boolean)"
      :key="item.market_hash_name"
      :item="item"
    />
  </div>
</template>

<script lang="ts" setup>
import type { InventoryRarePopularItem } from '~/graphql/generated/schema-types';

defineProps<{
  items: InventoryRarePopularItem[]
}>();
</script>

<style lang="scss" scoped>
.inventory-items-list {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fill, minmax(145px, 1fr));
  @media screen and (max-width: 768px) {
    gap: 8px;
  }
}
</style>
